import { MinusOutlined, PlusOutlined } from '@ant-design/icons';
import { Button, Form, Row } from 'antd';
import { RuleObject } from 'antd/es/form';
import dayjs from 'dayjs';
import React, { useContext, useEffect, useState } from 'react';

import ButtonComponent from 'components/atoms/ButtonComponent';
import DatePickerComponent from 'components/atoms/DatePickerComponent';
import InputComponent from 'components/atoms/InputComponent';
import InputNumberComponent from 'components/atoms/InputNumberComponent';
import Paragraph from 'components/atoms/Paragraph';
import SelectComponent from 'components/atoms/SelectComponent';
import Title from 'components/atoms/Title';
import LoadingWrapper from 'components/hoc/LoadingWrapper';
import { Context } from 'components/hoc/Store';
import TranslateText from 'components/hoc/TranslateText';
import PrilohyTable from 'components/molecules/Dokumenty/PrilohyTable';
import FormWrapper from 'components/molecules/FormWrapper';

import useProfily from 'hooks/useProfily';

import { IDodatekIsins, dokumentDodatekIsinGet, dokumentDodatekIsinPut } from 'services/dokumenty/dodatek';
import {
    INavyseniDluh,
    INavyseniOstatni,
    INavyseniSicav,
    NavyseniDluhGet,
    NavyseniDluhPut,
    NavyseniOstatniGet,
    NavyseniOstatniPut,
    NavyseniSicavGet,
    NavyseniSicavPut
} from 'services/dokumenty/navyseni';

import { EDruhCp } from 'enums/isin/udaje/druhCp';
import { ETrueFalse } from 'enums/trueFalse';

import { rozsahPpnSelect } from 'data/codebooks/dokumenty/rozsahPpnSelect';
import trueFalseSelect from 'data/codebooks/trueFalseSelect';

import isinValidation from 'utils/validations/isinValidation';

interface INavyseniDetail {
    nextStep: () => void;
    prevStep: () => void;
    zadostID: number;
    dodatekData?: IDodatekIsins;
    setDotatekData: React.Dispatch<React.SetStateAction<IDodatekIsins | undefined>>;
    signingDisabled: boolean;
    isDLT?: boolean;
}

const NavyseniDetail: React.FC<INavyseniDetail> = ({
    nextStep,
    prevStep,
    zadostID,
    dodatekData,
    setDotatekData,
    signingDisabled,
    isDLT
}) => {
    const { setLevel } = useProfily();
    const { cisMeny, dokumenty } = useContext(Context);
    const [formDisplayOnly] = Form.useForm();
    const [form] = Form.useForm();
    const [loading, setLoading] = useState<boolean>(false);
    const [, rerender] = useState<boolean>(false);
    const [data, setData] = useState<INavyseniOstatni>();
    const [cpData, setCpData] = useState<INavyseniDluh | INavyseniSicav>();
    const [kuponyIsins, SetKuponyIsins] = useState<{ isin?: string }[]>([
        {
            isin: undefined
        }
    ]);

    useEffect(() => {
        setLoading(true);
        dokumentDodatekIsinGet(zadostID)
            .then(resp => {
                const respFormated = {
                    ...resp,
                    data: JSON.parse(resp.data as any)
                };

                setDotatekData(respFormated);
                setLevel('dokumenty', {
                    ...dokumenty,
                    selectedZadost: {
                        ...dokumenty?.selectedZadost!,
                        druhcp: dodatekData?.druhcp
                    }
                });
                if (respFormated.druhcp === EDruhCp.NASTROJKOLINV) {
                    NavyseniSicavGet(zadostID)
                        .then(response => {
                            setData({} as INavyseniOstatni);
                            setCpData(response);
                        })
                        .catch(() => {
                            setCpData({} as INavyseniSicav);
                            setData({} as any);
                        })
                        .finally(() => setLoading(false));
                } else {
                    NavyseniOstatniGet(zadostID)
                        .then(response => {
                            setData(response);
                            form.setFieldsValue({
                                zamestakcppn:
                                    typeof data?.zamestakcppn === 'boolean' ? String(data?.zamestakcppn) : undefined
                            });
                            respFormated.druhcp !== EDruhCp.DLUHOPIS && setCpData({} as any);
                        })
                        .catch(() => {
                            setData({} as INavyseniOstatni);
                            setCpData({} as any);
                        })
                        .finally(() => setLoading(false));
                    respFormated.druhcp === EDruhCp.DLUHOPIS
                        ? NavyseniDluhGet(zadostID)
                              .then(response => {
                                  setCpData(response);
                                  response.zvysisin.length && SetKuponyIsins(response.zvysisin);
                              })
                              .catch(() => setCpData({} as INavyseniDluh))
                              .finally(() => setLoading(false))
                        : null;
                }
            })
            .catch(() => setLoading(false));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [zadostID]);

    return (
        <LoadingWrapper loading={loading}>
            {dodatekData && data && cpData && (
                <>
                    <FormWrapper outForm={formDisplayOnly} onFinish={() => {}}>
                        <Title text="ISIN_PARAMS" level={5} />
                        <InputComponent
                            disabled={true}
                            initialValue={dodatekData?.isin}
                            label="ISIN"
                            name="isin"
                            notRequired={true}
                        />

                        <InputComponent
                            disabled={true}
                            initialValue={dodatekData?.nazev}
                            label="NAZEV_EMISE"
                            name="nazev2"
                            notRequired={true}
                        />
                        <InputComponent
                            disabled={true}
                            initialValue={dodatekData?.cfi}
                            label="CFI"
                            name="cfi"
                            notRequired={true}
                        />

                        {/*  <Title text="DOKUMNET_DODATEK_ISINDETAIL_TITLE" level={4} />
                        <UdajeEmise
                            cisMeny={cisMeny}
                            nextStep={() => {}}
                            prevStep={() => {}}
                            setDruhCP={() => {}}
                            setIdentifikacePutData={() => {}}
                            setUdajeEmise={() => {}}
                            setRozcestnikInput={() => {}}
                            prevStepRef={0}
                            udajeEmise={convertToBooleans(dodatekData.data)}
                            displayOnly={true}
                            druhCP={dodatekData.druhcp}
                        />
                        <Title level={5} text="DOPLNUJICI_INFORMACE" dividerTitle={true} />
                        <InputComponent
                            maxLength={19}
                            name="kapital"
                            label="ISIN_IDENTIFIKACE_KAPITAL"
                            initialValue={
                                typeof dodatekData?.kapital === 'number'
                                    ? formatInputNumberThousand(Number(dodatekData?.kapital))
                                    : undefined
                            }
                            disabled={true}
                            notRequired={true}
                        />
                        <SelectComponent
                            name="menaInfo"
                            labelParagraph="MENA"
                            isFormItem={true}
                            data={cisMeny}
                            defaultValue={dodatekData.mena}
                            disabled={true}
                            notRequired={true}
                        />
                        <InputComponent
                            label="ISIN_IDENTIFIKACE_SPLACENO"
                            name="splaceno"
                            initialValue={dodatekData?.splaceno}
                            maxLength={5}
                            disabled={true}
                            notRequired={true}
                        />*/}
                    </FormWrapper>
                    <FormWrapper
                        outForm={form}
                        onFinish={values => {
                            setLoading(true);
                            const dodatekNewVals = {
                                ...dodatekData,
                                ...(values.datregistr && {
                                    datregistr: values.datregistr.format('YYYY-MM-DD')
                                }),
                                ...(values.datzaknih && {
                                    datzaknih: values.datzaknih.format('YYYY-MM-DD')
                                }),
                                ...(values.premena && {
                                    premena: values.premena === ETrueFalse.TRUE
                                }),
                                ...(values.premena === ETrueFalse.TRUE && {
                                    denupllhu: values.denupllhu.format('YYYY-MM-DD'),
                                    denupldodatlhu: values.denupldodatlhu.format('YYYY-MM-DD'),
                                    denuplmaju: values.denuplmaju.format('YYYY-MM-DD')
                                }),
                                ...(dodatekData.typprevodu && {
                                    typprevodu: dodatekData.typprevodu,
                                    ...(dodatekData.zpuspredvp && {
                                        zpuspredvp: dodatekData.zpuspredvp
                                    }),
                                    ...(dodatekData.zpuspredfp && {
                                        zpuspredfp: dodatekData.zpuspredfp
                                    })
                                })
                            };
                            dokumentDodatekIsinPut(zadostID, dodatekNewVals)
                                .then(() => {
                                    setDotatekData(dodatekNewVals);
                                    const generalData = {
                                        ...(values.zamestakcppn && {
                                            zamestakcppn: values.zamestakcppn === ETrueFalse.TRUE
                                        }),
                                        ...(values.rozsahppn && {
                                            rozsahppn: values.rozsahppn
                                        }),
                                        pocetcpp: values.pocetcpp,
                                        pocetcpn: values.pocetcpn,
                                        poccpzvys: values.poccpzvys
                                    };
                                    const kuponyIsinsToSend = (kuponyIsins || [])
                                        .map((_e, i) => {
                                            const returnObj = {
                                                isin: values[`isin${i}`]
                                            };
                                            delete values[`isin${i}`];
                                            return returnObj;
                                        })
                                        .filter(e => e.isin);

                                    const druhCpData =
                                        dodatekData.druhcp === EDruhCp.DLUHOPIS
                                            ? {
                                                  ...(values.isinjistiny && {
                                                      isinjistiny: values.isinjistiny
                                                  }),
                                                  ...(kuponyIsinsToSend.length && {
                                                      zvysisin: kuponyIsinsToSend
                                                  })
                                              }
                                            : dodatekData.druhcp === EDruhCp.NASTROJKOLINV
                                              ? {
                                                    poccpzvys: values.poccpzvys,
                                                    mena: values.mena,
                                                    navakcie: values.navakcie,
                                                    ...(values.datkurzu && {
                                                        datkurzu: values.datkurzu.format('YYYY-MM-DD')
                                                    })
                                                }
                                              : null;
                                    if (druhCpData) {
                                        if (dodatekData.druhcp === EDruhCp.DLUHOPIS) {
                                            NavyseniDluhPut(zadostID, druhCpData as INavyseniDluh).finally(() =>
                                                setLoading(false)
                                            );
                                        } else {
                                            NavyseniSicavPut(zadostID, druhCpData as INavyseniSicav)
                                                .then(() => nextStep())
                                                .finally(() => setLoading(false));
                                        }
                                    }
                                    if (dodatekData.druhcp !== EDruhCp.NASTROJKOLINV) {
                                        NavyseniOstatniPut(zadostID, generalData).then(() => {
                                            nextStep();
                                        });
                                    }
                                })
                                .catch(() => {
                                    setLoading(false);
                                });
                        }}
                    >
                        {dodatekData.druhcp === EDruhCp.DLUHOPIS ? (
                            <>
                                <Title
                                    text="DODATEK_NAVYSENI_DETAIL_DLUHOPIS_ISIN_TITLE"
                                    dividerTitle={true}
                                    level={5}
                                />
                                <InputComponent
                                    label="DODATEK_NAVYSENI_DETAIL_DLUHOPIS_ISIN_JISTINY"
                                    name="isinjistiny"
                                    maxLength={12}
                                    rules={isinValidation()}
                                    initialValue={(cpData as INavyseniDluh)?.isinjistiny}
                                    capitalize={true}
                                    notRequired={true}
                                    disabled={signingDisabled}
                                />
                                {(kuponyIsins || []).map((e, i) => (
                                    <InputComponent
                                        label="DODATEK_NAVYSENI_DETAIL_DLUHOPIS_ISIN_KUPONU"
                                        key={`isin${i}`}
                                        name={`isin${i}`}
                                        maxLength={12}
                                        initialValue={e.isin}
                                        rules={isinValidation()}
                                        notRequired={true}
                                        capitalize={true}
                                        disabled={signingDisabled}
                                        labelExtra={
                                            i === kuponyIsins.length - 1 || i === 0 ? (
                                                <Button
                                                    id="c2PlusAltBtn"
                                                    htmlType="button"
                                                    type="primary"
                                                    style={{
                                                        display: 'inline-block',
                                                        marginLeft: 20,
                                                        width: 50
                                                    }}
                                                    defaultValue={e.isin}
                                                    disabled={signingDisabled}
                                                    icon={i === 0 ? <PlusOutlined /> : <MinusOutlined />}
                                                    onClick={() => {
                                                        if (i === 0)
                                                            SetKuponyIsins(pv => [
                                                                ...pv,
                                                                {
                                                                    isin: undefined
                                                                }
                                                            ]);
                                                        else {
                                                            form.setFieldsValue({
                                                                [`isin${i}`]: undefined
                                                            });
                                                            SetKuponyIsins(pv => pv.filter((_e, index) => i !== index));
                                                        }
                                                    }}
                                                />
                                            ) : null
                                        }
                                    />
                                ))}
                            </>
                        ) : (
                            <></>
                        )}
                        {dodatekData.druhcp !== EDruhCp.NASTROJKOLINV && (
                            <>
                                <Title
                                    text="DODATEK_NAVYSENI_DETAIL_DLUHOPIS_POCET_TITLE"
                                    dividerTitle={true}
                                    level={5}
                                />
                                {/* dodatekData.druhcp === EDruhCp.DLUHOPIS && (
                            <InputNumberComponent
                                name="cislotranse"
                                label="DODATEK_NAVYSENI_DETAIL_DLUHOPIS_CISLO_TRANSE"
                                initialValue={(cpData as INavyseniDluh)?.cislotranse}
                                disabled={signingDisabled}
                            />
                        ) */}
                                <InputNumberComponent
                                    name="pocetcpp"
                                    label="DODATEK_NAVYSENI_DETAIL_AKCIE_STAVAJICI_CP"
                                    disabled={signingDisabled}
                                    initialValue={data?.pocetcpp}
                                    precision={0}
                                    onChangeCustom={val => {
                                        form.setFieldsValue({
                                            pocetcpn:
                                                form.getFieldValue('poccpzvys') && val
                                                    ? Number(form.getFieldValue('poccpzvys')) + Number(val)
                                                    : undefined
                                        });
                                        rerender(pv => !pv);
                                    }}
                                />
                                <InputNumberComponent
                                    name="poccpzvys"
                                    label="DODATEK_NAVYSENI_DETAIL_AKCIE_ZAKNIHOVANE_CP"
                                    disabled={signingDisabled}
                                    initialValue={data?.poccpzvys}
                                    onChangeCustom={val => {
                                        form.setFieldsValue({
                                            pocetcpn:
                                                form.getFieldValue('pocetcpp') && val
                                                    ? Number(form.getFieldValue('pocetcpp')) + Number(val)
                                                    : undefined
                                        });
                                        rerender(pv => !pv);
                                    }}
                                    rules={[
                                        () => ({
                                            validator(_rule: RuleObject, value: string) {
                                                if (!value || Number(value) > 0) return Promise.resolve();
                                                return Promise.reject(
                                                    <TranslateText>NEVALIDNI_PROCENTA_100_06_0</TranslateText>
                                                );
                                            }
                                        })
                                    ]}
                                />
                                <InputNumberComponent
                                    name="pocetcpn"
                                    label="DODATEK_NAVYSENI_DETAIL_AKCIE_CELKOM_CP"
                                    initialValue={data?.pocetcpn}
                                    precision={0}
                                    disabled={true}
                                    notRequired={true}
                                />
                            </>
                        )}
                        {dodatekData.druhcp === EDruhCp.NASTROJKOLINV && (
                            <>
                                <InputNumberComponent
                                    name="poccpzvys"
                                    label="DODATEK_NAVYSENI_DETAIL_AKCIE_ZAKNIHOVANE_CP"
                                    initialValue={(cpData as INavyseniSicav)?.poccpzvys}
                                    disabled={signingDisabled}
                                />
                                <InputNumberComponent
                                    name="navakcie"
                                    label="DODATEK_INVCERT_NAV"
                                    initialValue={(cpData as INavyseniSicav)?.navakcie}
                                    disabled={signingDisabled}
                                    precision={4}
                                />
                                <SelectComponent
                                    name="mena"
                                    labelParagraph="DODATEK_INVCERT_NAV_MENA"
                                    isFormItem={true}
                                    data={cisMeny}
                                    onChange={() => rerender(pv => !pv)}
                                    defaultValue={(cpData as INavyseniSicav)?.mena}
                                    disabled={signingDisabled}
                                />
                                {form.getFieldValue('mena') && form.getFieldValue('mena') !== 'CZK' && (
                                    <DatePickerComponent
                                        name="datkurzu"
                                        initialValue={
                                            (cpData as INavyseniSicav)?.datkurzu
                                                ? dayjs((cpData as INavyseniSicav).datkurzu)
                                                : undefined
                                        }
                                        label="DODATEK_INVCERT_NAV_DATUM"
                                        disabled={signingDisabled}
                                    />
                                )}
                            </>
                        )}
                        {dodatekData.druhcp === EDruhCp.DLUHOPIS && (
                            <Paragraph
                                style={{
                                    display: 'block',
                                    fontWeight: 'bold'
                                }}
                                text="DODATEK_NAVYSENI_DETAIL_DLUHOPIS_TEXT"
                            />
                        )}
                        {dodatekData.druhcp === EDruhCp.AKCIE && (
                            <>
                                <SelectComponent
                                    name="zamestakcppn"
                                    labelParagraph="DOKUMENT_DODATEK_DETAIL_VYBRANECP"
                                    isFormItem={true}
                                    data={trueFalseSelect}
                                    defaultValue={
                                        typeof data?.zamestakcppn === 'boolean' ? String(data?.zamestakcppn) : undefined
                                    }
                                    disabled={signingDisabled}
                                    onChange={() => rerender(pv => !pv)}
                                />
                                {form.getFieldValue('zamestakcppn') === 'true' && (
                                    <SelectComponent
                                        name="rozsahppn"
                                        labelParagraph="DOKUMENT_DODATEK_DETAIL_VYBRANECP_ANO"
                                        isFormItem={true}
                                        data={rozsahPpnSelect}
                                        defaultValue={data?.rozsahppn}
                                        disabled={signingDisabled}
                                    />
                                )}
                            </>
                        )}
                        <DatePickerComponent
                            name="datzaknih"
                            label={'DODATEK_NAVYSENI_DETAIL_DATUM'}
                            initialValue={dodatekData?.datzaknih ? dayjs(dodatekData.datzaknih) : undefined}
                            disabledDate={current => current < dayjs()}
                            disabled={signingDisabled}
                        />
                        <Title level={5} text="DOKUMENT_DODATEK_DETAIL_ZAKN_NABYVATELE" />
                        <Paragraph
                            text={
                                isDLT
                                    ? 'DOKUMENT_DODATEK_DETAIL_ZAKN_NABYVATELE_DLT_TEXT'
                                    : 'DOKUMENT_DODATEK_DETAIL_ZAKN_NABYVATELE_TEXT_NAVYSENI'
                            }
                            style={{
                                display: 'block',
                                marginBottom: 10
                            }}
                        />
                        <PrilohyTable zadostID={zadostID} />
                        <Row className="button-row">
                            <ButtonComponent
                                buttontext="ZPET"
                                onClick={() => prevStep()}
                                id="isinZpetBtn"
                                type="default"
                            />
                            <ButtonComponent buttontext="POKRACOVAT" htmlType="submit" id="isinPokracovatBtn" />
                        </Row>
                    </FormWrapper>
                </>
            )}
        </LoadingWrapper>
    );
};

export default NavyseniDetail;
